import { createStore } from "vuex";
import auth from "./modules/auth";
import license from "./modules/license";

export default createStore({
  modules: {
    auth,
    license,
  },
});
